export const SET_SEARCH_KEY = "SET_SEARCH_KEY";
export const SET_SPECIALITIES = "SET_SPECIALITIES";
export const SET_SEARCH_RESULT = "SET_SEARCH_RESULT";
export const setSearchTemplate = (payload) => {
   return {
      type: SET_SEARCH_KEY,
      payload: payload,
   };
};

export const setSpecialities = (payload) => {
   return {
      type: SET_SPECIALITIES,
      payload: payload,
   };
};

export const setSearchResult = (payload) => {
   return {
      type: SET_SEARCH_RESULT,
      payload: payload,
   };
};
